import { Config } from './schema';

const config = import.meta.env as unknown as Config;

export default config;
